import { render, staticRenderFns } from "./SkeletonInvoiceReceipts.vue?vue&type=template&id=4462031e&scoped=true"
import script from "./SkeletonInvoiceReceipts.vue?vue&type=script&lang=ts"
export * from "./SkeletonInvoiceReceipts.vue?vue&type=script&lang=ts"
import style0 from "./SkeletonInvoiceReceipts.vue?vue&type=style&index=0&id=4462031e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4462031e",
  null
  
)

export default component.exports